import { motion } from "framer-motion";
import { reveal, IMAGES } from "@/lib/motion";

const chapters = [
  {
    num: "01",
    title: "We teach the sound before the syllabus.",
    body: "Every learner begins with rhythm, pronunciation and confidence — because a language is spoken long before it is examined.",
  },
  {
    num: "02",
    title: "Private tuition, not a crowded room.",
    body: "Personalised attention for board and competitive Hindi exams, mapped to each student's pace, gaps and goals.",
  },
  {
    num: "03",
    title: "Hindi as a career, not just a subject.",
    body: "From workplace communication to literature, we open doors that fluency in an Indian language quietly unlocks.",
  },
];

export default function Manifesto() {
  return (
    <section
      id="about"
      data-testid="manifesto-section"
      className="relative py-28 md:py-40 bg-foreground text-background overflow-hidden"
    >
      <span className="font-deva pointer-events-none select-none absolute -left-10 bottom-0 text-background/5 text-[40vw] leading-none">
        भ
      </span>

      <div className="max-w-[1400px] mx-auto px-6 md:px-10 relative z-10">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-8 mb-20">
          <span className="md:col-span-3 overline text-primary">
            02 — Our philosophy
          </span>
          <p className="md:col-span-7 font-serif-editorial italic text-3xl md:text-5xl leading-tight text-background/90">
            A new life for an old language — नवजीवन.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-12 gap-8 items-start">
          <div className="md:col-span-7 space-y-px">
            {chapters.map((c, i) => (
              <motion.div
                key={c.num}
                data-testid={`manifesto-chapter-${i}`}
                variants={reveal}
                custom={i}
                initial="hidden"
                whileInView="show"
                viewport={{ once: true, margin: "-60px" }}
                className="border-t border-background/15 py-8 grid grid-cols-12 gap-4"
              >
                <span className="col-span-2 font-display font-bold text-primary text-xl">
                  {c.num}
                </span>
                <div className="col-span-10">
                  <h3 className="font-display font-bold text-2xl md:text-3xl tracking-tight mb-3">
                    {c.title}
                  </h3>
                  <p className="font-body text-background/70 leading-relaxed max-w-xl">
                    {c.body}
                  </p>
                </div>
              </motion.div>
            ))}
          </div>

          <motion.div
            initial={{ opacity: 0, y: 40 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.9, ease: [0.22, 1, 0.36, 1] }}
            className="md:col-span-5 clip-frame"
          >
            <img
              src={IMAGES.instituteMain}
              alt="Navjeevan Hindi Institute interior"
              className="w-full h-[560px] object-cover grayscale"
            />
          </motion.div>
        </div>
      </div>
    </section>
  );
}
